var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "VARG",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "54.48px",
    height: "37.44px",
    viewBox: "0 0 54.48 37.44",
    enableBackground: "new 0 0 54.48 37.44",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54.48,
    height: 37.44
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.92,
    y: 1.92,
    fill: "#FFFFFF",
    width: 50.64,
    height: 33.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.24,23.28c-0.068,0.925,0.307,3.25-3.84,3.36c-4.815-0.11-4.478-3.373-4.56-4.56c0.008-1.137,0.008-3.575,0-6.48 c0.158-2.87,0.307-4.97,4.8-5.04c4.657,0.07,4.245,3.37,4.32,4.32c0.187,0.288,0.337,0.625,1.2,0.72h2.64 c0.622-0.095,0.885-0.545,0.96-0.96V10.8c-0.075-0.545-0.375-1.145-1.2-1.44c-1.5-0.305-4.65-0.492-7.44-0.48 c-6.435,0.063-7.71,0.85-8.64,1.68c-1.02,0.82-2.52,1.12-2.4,7.68c-0.12,6.64,0.18,7.24,1.2,8.4c1.23,1.24,6.03,1.84,8.64,1.68 c1.959,0.085,5.452-0.102,9.12-1.2c0.27-0.177,0.57-0.44,0.48-0.96v-2.64v-0.24c0.09-1.699,0.99-2.712,2.16-2.64 c0.517-0.072,0.817-0.373,0.72-0.72v-0.48c0.097-0.316-0.053-0.71-0.48-0.72H39.84c-0.592,0.01-0.742,0.404-0.72,0.72v0.48 c-0.022,0.347,0.277,0.648,0.72,0.72C41.498,20.605,42.21,21.581,42.24,23.28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.52,27.84c0.296,0.115,0.503-0.054,0.48-0.24v-0.72c0.023-0.388-0.259-0.519-0.48-0.48 c-3.172-0.095-4.147-1.109-4.08-2.88v-2.88h6.24c2.43-0.11,6.48-0.26,6.48-6.24c0-4.482-2.7-5.082-6-5.04H4.8 C4.504,9.318,4.148,9.599,4.08,9.84v0.72c0.068,0.37,0.461,0.501,0.72,0.48c2.235,0.04,3.285,1.091,3.36,2.88v9.6 c-0.075,1.771-1.237,2.822-3.36,2.88c-0.371-0.039-0.652,0.092-0.72,0.48v0.72c0.068,0.186,0.274,0.355,0.48,0.24H17.52z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M13.44,11.28h4.08c2.378-0.012,2.753,1.675,2.64,3.36c0.113,1.765-0.15,3.94-2.4,3.84h-4.32V11.28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPg);
export default __webpack_public_path__ + "static/media/PG.92ce666124e82f348287ecffbe7c5d31.svg";
export { ForwardRef as ReactComponent };